@if (showLdr) {
<ds-loading></ds-loading>
}
<div class="row hdrBar">
  <div class="col-lg-12 col-md-12 mg-a">
    @if (clntDtls && clntDtls.length > 0) {
    <h1>Trips Operations</h1>
    }
  </div>
</div>
<div class="main">
  <div class="row">
    <div class="col-lg-3 col-md-3">
      <div class="drpLbl">Select Date</div>
      <nz-date-picker
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="slctdDt"
        style="width: 100%"
        (ngModelChange)="onChange($event)"
      ></nz-date-picker>
    </div>
    @if (tntLst.length>1) {
    <div class="col-lg-3 col-md-3">
      <div class="drpLbl">Select ULB</div>
      <nz-select
        class="slctBx"
        nzShowSearch
        [(ngModel)]="selectedtenant"
        (ngModelChange)="ontntSelect($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        @for (t of tntLst; track t) {
        <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_dsply_nm"></nz-option>
        }
      </nz-select>
    </div>
    } @if (tntLst.length==1) {
    <div class="col-lg-3 col-md-3">
      <div class="drpLbl">ULB</div>
      <div class="slctBx disbledtxt">{{ tntLst[0].tnt_nm }}</div>
    </div>
    }
    <div class="col-lg-3 col-md-3">
      <div class="drpLbl">Select Vehicle</div>
      <nz-select
        class="slctBx"
        nzShowSearch
        [(ngModel)]="selectedVehicle"
        (ngModelChange)="onvehcleSelect($event)"
        nzPlaceHolder="Select Vehicle"
        [ngModelOptions]="{ standalone: true }"
        style="width: 100%"
      >
        @for (v of vhcleslst; track v) {
        <nz-option [nzLabel]="v.asrt_nm" [nzValue]="v.asrt_id"></nz-option>
        }
      </nz-select>
    </div>
  </div>
</div>
<div class="row bg-wp">
  <div class="col-lg-8 col-md-8 col-sm-8">
    <h1 style="text-align: left">Trips {{ curDate }}</h1>
  </div>

  <div class="ds-card grid tbl">
    <app-data-grid
      [groupItems]="gridGroups0"
      class="p-8"
      style="width: 100%"
      [dataSource]="tripDtls"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="Trips Travelled
                 Data"
      [pageSize]="10"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
      (cellClick)="onCellClick($event)"
      [cellPrepared]="bound_onCellPrepared"
    >
      <!-- -->

      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        type="buttons"
        [width]="100"
        caption="Clear Trip"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="clearTrip(data)">
            <p>Clear Trip</p>
          </div>
        </div></ng-template
      >

      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        type="buttons"
        [width]="100"
        caption="Assign Vehicle"
        cellTemplate="trpsdata"
      ></app-grid-column>
      <ng-template appGridCell="trpsdata" let-data="cell"
        ><div>
          <div class="tblAddBtn" (click)="assgnVehicle(data)">
            <p>Assign</p>
          </div>
        </div></ng-template
      >

      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        type="buttons"
        [width]="100"
        caption="Start Trip"
        cellTemplate="trpsdata1"
      ></app-grid-column>
      <ng-template appGridCell="trpsdata1" let-data="cell"
        ><div>
          <div class="tblAddBtn" (click)="startTrip(data)">
            <p>start</p>
          </div>
        </div></ng-template
      >
    </app-data-grid>
  </div>
</div>
